import { gql } from "graphql-tag"

import blog from "./blog"
import content from "./content"
import contests from "./contests"
import dashboard from "./dashboard"
import eightLeggedFreak from "./eightLeggedFreak"
import emails from "./emails"
import forum from "./forum"
import homeVideoReviews from "./homeVideoReviews"
import homeVideos from "./homeVideos"
import news from "./news"
import newsletters from "./newsletters"
import socials from "./socials"
import tmdb from "./tmdb"
import vendors from "./vendors"

const query = gql`
  ${blog}
  ${content}
  ${contests}
  ${dashboard}
  ${eightLeggedFreak}
  ${emails}
  ${forum}
  ${homeVideoReviews}
  ${homeVideos}
  ${news}
  ${newsletters}
  ${socials}
  ${tmdb}
  ${vendors}

  type Query {
    getSiteUsersByContestId(contestId: ID!): [SiteUser]

    me: User

    omdbId(id: String!, serviceName: String!): String

    reviews(serviceName: String!): [Review]
  }
`

export default query
